export default __webpack_public_path__ + "static/media/old_yarden_logo.088d9c3a.jpg";